import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import './clockComp.scss';

function ClockComp({ active }) {
	const timer = useSelector((state) => state.clock.turnDuration);

	return (
		<>
			{active ? (
				<div className="clock-countdown" data-timeout={timer}></div>
			) : null}
		</>
	);
}

export default ClockComp;
